import type { FC } from 'react';
import React from 'react';
import { ComboButtonWrapper, PrimaryButton, SecondaryButton } from './comboButton.styled';
import type { ButtonType } from './index';

export type ComboButtonType = Pick<ButtonType, 'disabled'> & {
    primary: Pick<ButtonType, 'onClick' | 'children' | 'fluid' | 'iconPosition' | 'iconName' | 'id'>;
    secondary?: Pick<ButtonType, 'onClick' | 'iconName' | 'id'>;
};

const ComboButton: FC<ComboButtonType> = ({ primary, secondary, disabled }) => (
    <ComboButtonWrapper>
        <PrimaryButton {...primary} disabled={disabled} />
        {secondary && <SecondaryButton {...secondary} disabled={disabled} />}
    </ComboButtonWrapper>
);

export default ComboButton;
